import { useMetadata } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect, useReducer } from 'react'

import { getInitialState, reducer } from '../state/reducer'
import { Category } from '../typings/Category'
import { SecondTryContext } from './SecondTryContext'

interface SecondTryIntroData {
  category: Category
  businessName: string
  selectedApps: string[]
}

export const SecondTryProvider: FC = ({ children }) => {
  const [{ secondTry }] = useMetadata()
  const [state, dispatch] = useReducer(reducer, { prefilledInput: '' }, getInitialState)

  useEffect(() => {
    let introData: SecondTryIntroData | undefined
    try {
      introData = JSON.parse(secondTry || '{}')
    } catch (e) {
      console.error('Failed to parse introData from metadata.secondTry', e)
    }

    const category: Category = introData?.category
      ? {
          structureId: introData.category.structureId,
          industryId: introData.category.industryId,
          postRegVertical: introData.category.postRegVertical,
          displayName: introData.category.displayName,
          businessSegmentId: introData.category.businessSegmentId,
        }
      : {}
    const businessName = introData?.businessName ?? ''
    const appDefIds = introData?.selectedApps ?? []

    dispatch({ type: 'setIntroData', introData: { category, businessName, appDefIds } })
    dispatch({ type: 'setBusinessName', businessName })
    dispatch({ type: 'setSelectedAppDefIds', appDefIds })
    dispatch({ type: 'changeSearch', search: category.displayName || '' })
  }, [])

  return <SecondTryContext.Provider value={{ ...state, dispatch }}>{children}</SecondTryContext.Provider>
}
